import type {ShortcutCommandGroup} from '../types';

export const shortcutCommandGroups: ShortcutCommandGroup[] = [
  'global',
  'cataloguing',
  'overview',
  'search',
  'uncategorized',
];
